import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/auth.service';
import { UsersService } from '../../../users/users.service';
import { BaseService } from '../../../shared/base.service';
import { HomeService } from '../../home.service';
import { TokensService } from './tokens.service';
import { TokenModel } from './tokens.model';
import { BaseComponent } from '../../../shared/base.component';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tokens-component',
    templateUrl: './tokens.component.html',
    styleUrls: ['./tokens.component.scss'],
    providers: [UsersService, BaseService, HomeService, TokensService]
})

export class TokensComponent extends BaseComponent implements OnInit, OnDestroy {

    items : Object[] = [];
    subscription : Subscription;
    tokenText = 'Copy token';
    tokenUrl = 'Copy token URL';

    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        ['description', 'Description', 'col-xs-2', 'text'],
        ['code', 'Token', 'col-xs-2', 'token'],
        ['created_at_diff', 'Created at', 'col-xs-2', 'text'],
        ['last_used_diff', 'Last used at', 'col-xs-2', 'text'],
        ['usages', 'Calls', 'col-xs-1', 'text'],
        ['inactive_at_diff', '', 'col-xs-3', 'text'],
    ];
   
    /**
     *
     * @param authService
     * @param router
     * @param baseService
     * @param appService
     * @param usersService
     */
    constructor(public authService: AuthService,
                public router: Router,
                public route: ActivatedRoute,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public tokensService: TokensService,
                public fb: FormBuilder,
                @Inject('konektoDomain') public konektoDomain : string,
                ) {

        super(authService, router, baseService, appService);
    }

    /**
     * Component Init
     */
    ngOnInit() {

        this.searchInfo = new TokenModel();
        super.ngOnInit();

        this.url = 'insurance-dashboard/tokens';
        this.getItems();

        this.subscription = this.router.events
        .subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url.indexOf('create') >= 0) {
                    return true;
                }
                this.isUpdated = true;
                this.getItems();
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    copyText(text) {
        navigator.clipboard.writeText(text);
    }

    openFormModal(params: Object) {
        this.initForm(params);

        this.form = this.fb.group({
            description: ['', [<any>Validators.required]],
        });
        this.showModal();
    }
}
